import { Converter } from '../types/converter';

export const fuelEfficiencyVolumeConverter: Converter = {
  id: 'fuelEfficiencyVolume',
  name: 'Volume Fuel Efficiency Converter',
  icon: 'Fuel',
  categories: ['engineering'],
  units: [
    // Energy per volume units
    { name: 'Joule per cubic meter', symbol: 'J/m³', factor: 1 },
    { name: 'Joule per liter', symbol: 'J/L', factor: 1000 },
    { name: 'Megajoule per cubic meter', symbol: 'MJ/m³', factor: 1e6 },
    { name: 'Kilojoule per cubic meter', symbol: 'kJ/m³', factor: 1000 },
    { name: 'Kilocalorie (IT) per cubic meter', symbol: 'kcal/m³', factor: 4186.8 },
    { name: 'Calorie (IT) per cubic centimeter', symbol: 'cal/cm³', factor: 4.1868e6 },
    { name: 'Therm per cubic foot', symbol: 'therm/ft³', factor: 3.725895e6 },
    { name: 'Therm per gallon (UK)', symbol: 'therm/gal (UK)', factor: 1.0551e8 },
    { name: 'Btu (IT) per cubic foot', symbol: 'Btu/ft³', factor: 37258.95 },
    { name: 'Btu (th) per cubic foot', symbol: 'Btu (th)/ft³', factor: 37234.77 },
    { name: 'CHU per cubic foot', symbol: 'CHU/ft³', factor: 67066.11 },
    
    // Volume per energy units
    { name: 'Cubic meter per joule', symbol: 'm³/J', factor: 1 },
    { name: 'Liter per joule', symbol: 'L/J', factor: 0.001 },
    
    // Power-based units
    { name: 'Gallon (US) per horsepower', symbol: 'gal (US)/hp', factor: 0.00378541 }
  ]
};
